import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export function getLlmProviders() {
    return createAxios().get(Api.PATH_LLM_PROVIDERS);
};

export const removeLlmProvider = (id) => {
    return createAxios().delete(Api.PATH_LLM_PROVIDERS + "/" + id);
}

export const createLlmProvider = (values) => {
    return createAxios().post(Api.PATH_LLM_PROVIDERS, values);
};

export const updateLlmProvider = (id, values) => {
    return createAxios().put(`${Api.PATH_LLM_PROVIDERS}/${id}`, values);
};
